import PropTypes from 'prop-types';

const propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  image: PropTypes.node,
  category: PropTypes.string,
  createdAt: PropTypes.node,
  labels: PropTypes.arrayOf(PropTypes.string),
  withPageMargins: PropTypes.bool,
};

const defaultProps = {
  title: undefined,
  description: undefined,
  image: undefined,
  category: undefined,
  createdAt: undefined,
  labels: [],
  withPageMargins: false,
};

export {
  propTypes as default,
  defaultProps,
};
